import {
  getLocalStore,
  getSessionStore,
  decodeStr,
} from "@/utils";

const getters = {
  /*分页*/
  total: state => state.list.total, //分页的总条数
  start: state => state.list.start, //分页的开始条数
  limit: state => state.list.limit, //分页的结束条数
  rules: state => state.list.rules, //分页文字
  isLogin(state) {
    return state.user.isLogin;
  },

  getPoolToken(state) {
    return state.tokenInfo.poolToken || getLocalStore("HB-POOL-TOKEN") || "";
  },

  getLang(state) {
    return state.lang || "";
  },

  getUcToken(state) {
    return (
      state.tokenInfo.ucToken ||
      getToken("HB-UC-TOKEN") ||
      getLocalStore("HB-UC-TOKEN") ||
      ""
    );
  },

  getUserInfo(state) {
    if (state.user.userInfo) return state.user.userInfo;
    const localInfo = getLocalStore("userInfo");
    if (localInfo) return JSON.parse(decodeStr(localInfo));
    return null;
  },

  /**
   * @description: 获取币种列表
   */
  getCurrencyData(state) {
    if (state.user.currencyData) return state.user.currencyData;
    const localInfo = getSessionStore("currencyData");
    if (localInfo) return JSON.parse(decodeStr(localInfo));
    return [];
  },

  /**
 * @description: 获取挖矿技术
 */
  getMiningTechnology(state) {
    if (state.user.miningTechnology) return state.user.miningTechnology;
    const localInfo = getSessionStore("miningTechnology");
    if (localInfo) return localInfo;
    return 1;
  },

  /**
   * @description: 获取当前子账号名称
   */
  getAccountName(state) {
    if (state.user.accountName) return state.user.accountName;
    const sessionInfo = getSessionStore("accountName");
    if (sessionInfo) return sessionInfo;
    return null;
  },

  /**
   * @description: 获取当前挖矿币种
   */
  getMiningType(state) {
    if (state.user.miningType) return state.user.miningType;
    const sessionInfo = getSessionStore("miningType");
    if (sessionInfo) return sessionInfo;
    return null;
  },

  /**
   * @description: 获取当前筛选币种
   */
  getSearchCoin(state) {
    if (state.user.searchCoin) return state.user.searchCoin;
    const sessionInfo = getSessionStore("searchCoin");
    if (sessionInfo) return sessionInfo;
    return null;
  },
  /**
   * @description: 获取是否显示筛选币种下拉
   */
  getShowCoin(state) {
    return state.user.showCoin;
  },
  /**
   * @description: 获取是否显示修改密码弹窗
   */
  getShowModify(state) {
    return state.user.showModify;
  },
  /**
   * @description: 获取当前挖矿地址
   */
  getWalletAddr(state) {
    if (state.user.walletAddr) return state.user.walletAddr;
    const sessionInfo = getSessionStore("walletAddr");
    if (sessionInfo) return sessionInfo;
    return null;
  },
  showFootBar(state) {
    return state.showFootBar;
  }
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js